"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var canMoveCurrentSnapshot_1 = require("./canMoveCurrentSnapshot");
/**
 * Move current snapshot with the given step if can move this step. Otherwise no action and return null
 * @param snapshots The snapshots data structure to move
 * @param step The step to move
 * @returns If can move with the given step, returns the snapshot after move, otherwise null
 */
function moveCurrentSnapsnot(snapshots, step) {
    if (canMoveCurrentSnapshot_1.default(snapshots, step)) {
        snapshots.currentIndex += step;
        return snapshots.snapshots[snapshots.currentIndex];
    }
    else {
        return null;
    }
}
exports.default = moveCurrentSnapsnot;
//# sourceMappingURL=moveCurrentSnapsnot.js.map